"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _featureToggle = _interopRequireDefault(require("@guestyci/feature-toggle"));

var _config = require("./config");

var getConfig = function getConfig(env) {
  return ['production', 'sandbox'].includes(env) ? _config.featureToggleProduction : _config.featureToggleDevelopment;
};

var featureToggleInit = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var env, accountId, config;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            env = _ref.env, accountId = _ref.accountId;

            if (!window.featureToggle) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", window.featureToggle);

          case 3:
            if (env) {
              _context.next = 6;
              break;
            }

            console.error('[featureToggle] Failed to get environment');
            return _context.abrupt("return");

          case 6:
            _context.prev = 6;

            if (env !== 'production') {
              console.log("[featureToggle] init started with env ".concat(env));
            }

            config = getConfig(env);
            return _context.abrupt("return", _featureToggle["default"].init(config, accountId || 'anonymous'));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            console.error('[featureToggle] Failed to fetch accountId from token while init ', _context.t0.stack);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12]]);
  }));

  return function featureToggleInit(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = featureToggleInit;
exports["default"] = _default;